import {Component, OnInit} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Message} from '../../models/message.model';
import {AppService} from '../../services/app.service';

@Component({
    selector: 'u4-cpp-notificationbar',
    templateUrl: './notification-bar.component.html'
})
export class NotificationBarComponent implements OnInit {

    notification: BehaviorSubject<Message>;

    constructor(private appService: AppService) {
        this.notification = this.appService.notification;
    }

    // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
    ngOnInit() {}

    close(): void {
        this.notification.next(null);
    }

}
